<template lang="pug">
el-form.webhook(label-position="left" :rules="rules" label-width="140px" ref="form")
  el-form-item(:label="$t('WebHook.url')")
    el-input(v-model="form.url" placeholder="https://" class="select-method")
      el-select(v-model="form.method" slot="prepend" placeholder="Method")
        el-option(v-for="(method, index) in methods" :label="method" :value="method" :key="index")
  el-form-item(:label="$t('WebHook.header_item',{index: index+1})" class="items-margin"
               v-for="(header, index) in form.headers" :key="'header-' + header.id")
    el-input(v-model="header.key" placeholder="Name" class="key")
    el-input(v-model="header.value" placeholder="Value" class="value")
    el-button(class="drop" type="text" icon="el-icon-circle-close" @click="deleteHeader(header.id)")
  a.add_item(@click="addHeader")
    i.el-icon-circle-plus-outline {{ $t('WebHook.add_header') }}
  el-form-item(:label="$t('WebHook.body_type')" v-if="show.body")
    el-select(v-model="form.body_type")
      el-option(v-for="(type, index) in body_types" :label="type" :value="type" :key="index")
  el-form-item(:label="$t('WebHook.param_item',{index: index+1})" class="items-margin" v-if="show.body_params"
               v-for="(param, index) in form.body_params" :key="'param-' + param.id")
    el-input(v-model="param.key" placeholder="Key" class="key")
    el-input(v-model="param.value" placeholder="Value" class="value")
    el-button(class="drop" type="text" icon="el-icon-circle-close" @click="deletePrams(param.id)")
  a.add_item(@click="addParam" v-if="show.body_params")
    i.el-icon-circle-plus-outline {{ $t('WebHook.add_param') }}
  el-form-item(:label="$t('WebHook.raw_body')" class="items-margin" v-if="show.raw_body")
    el-input(type="textarea" v-model="form.raw_body" placeholder="Body")
</template>

<script>

export default {
  props: [ 'value' ],
  data() {
    return {
      methods: [
        "POST","GET","PUT","DELETE"
      ],
      body_types: [
        'none', 'form-data', 'x-www-form-urlencoded', 'raw'
      ],
      rules: {
        method: [
          { required: true, message: this.$t('WebHook.method_not_present'), trigger: 'blur' }
        ],
        url: [
          { required: true, type: 'url', message: this.$t('WebHook.url_error'), trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    addHeader() {
      const empty_event = {
        id: Date.now(),
        key: '',
        value: ''
      };
      if (this.form.headers) {
        this.form.headers.push(empty_event)
      } else {
        this.$set(this.form, 'headers', [empty_event]);
      }
    },
    deleteHeader(key) {
      const headers = this.form.headers;
      headers.some(function(header, index){
        if (header.id === key) headers.splice(index, 1);
      });
    },
    addParam() {
      const empty_param = {
        id: Date.now(),
        key: '',
        value: ''
      };
      if (this.form.body_params) {
        this.form.body_params.push(empty_param)
      } else {
        this.$set(this.form, 'body_params', [empty_param])
      }
    },
    deletePrams(key) {
      const body_params = this.form.body_params;
      body_params.some(function(body_param, index){
        if (body_param.id === key) body_params.splice(index, 1);
      });
    }
  },
  computed: {
    form: {
      get() { return this.value; },
      set(value) { this.$emit('input', value); }
    },
    show() {
      const show = {
        body: this.form.method !== 'GET' && this.form.method !== '',
        raw_body: this.form.body_type === 'raw'
      };
      show.body_params = show.body && (this.form.body_type === 'form-data' || this.form.body_type === 'x-www-form-urlencoded');
      return show;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/table-layout.scss";
.expiration-date-comment{
  margin-left: 20px;
  color: #aaaaaa;
}

.el-form.webhook {
  border-bottom: 1px solid $border;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.select-method ::v-deep {
  .el-input-group__prepend {
    width: 70px;
    background-color: #FFF;
  }
}
a.add_item {
  display: inline-block;
  padding: 3px 0 10px 140px;
  margin-bottom: 10px;
  cursor: pointer;
  i {
    &:before {
      padding-right: 4px;
    }
  }
}
.el-input.key ::v-deep {
  width: 30%;

  input {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.el-input.value ::v-deep {
  width: calc(100% - (30% + 40px));
  margin-left: -1px;

  input {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
.el-button.drop {
  width: 40px;
  font-size: 24px;
  vertical-align: middle;
  text-align: right;
  color: #E30;
}
.items-margin {
  margin-bottom: 0;
}
</style>
